<template>
  <div id="myDateShow">
    <div class="title">{{coupons.id?"修改":"新增"}} 消息</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">优惠券类型</div>
        <div class="value">
          <el-select class="w500" v-model="coupons.couponsType" placeholder="请选择优惠券类型">
            <el-option  v-for="item in couponsType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="line" v-if="coupons.couponsType=='固定可叠加'">
        <div class="key">可叠加次数</div>
        <div class="value">
          <el-input class="w500" v-model="coupons.superpositionCount" placeholder="请填写可同时使用但最大数"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">优惠券名称</div>
        <div class="value">
          <el-input class="w500" v-model="coupons.couponsName" maxlength="30" show-word-limit placeholder="请填写优惠券名称"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">优惠券副标题</div>
        <div class="value">
          <el-input class="w500" v-model="coupons.subtitle" maxlength="10" show-word-limit placeholder="请简单介绍改优惠券"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">优惠券额度</div>
        <div class="value">
          <el-input class="w500" v-model="coupons.faceValue" placeholder="填入优惠金额，如：5 表示5元或优惠5%，8表示8元或优惠8%"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">RNMID码</div>
        <div class="value">
          <el-input class="w500" v-model="coupons.rnmIdCode" maxlength="6" show-word-limit placeholder="优惠标识码的前6位"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">自领取后的有效天数</div>
        <div class="value">
          <el-input class="w500" v-model="coupons.validityNum" placeholder="请填写数字"></el-input>
        </div>
      </div>

<!--      <div class="line">-->
<!--        <div class="key">最终领取期限（过期不可领取）</div>-->
<!--        <div class="value">-->
<!--          <el-date-picker-->
<!--                  v-model="coupons.endReceiveDateByAdmin"-->
<!--                  type="datetime"-->
<!--                  placeholder="选择日期时间">-->
<!--          </el-date-picker>-->
<!--        </div>-->
<!--      </div>-->

      <div class="line">
        <div class="key">支持业务</div>
        <div class="value">
          <el-select class="w500" v-model="coupons.supportScenarios" placeholder="请选择优惠券类型">
            <el-option  v-for="item in supportScenarios"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="line">
        <div class="key">领取场景</div>
        <div class="value">
          <el-select class="w500" v-model="coupons.getScenarios" placeholder="领取场景">
            <el-option  v-for="item in getScenarios"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="line">
        <div class="key">单张可用次数</div>
        <div class="value">
          <el-input class="w500" v-model="coupons.couponsCount" placeholder="请填写数字"></el-input>
        </div>
      </div>

      <div class="line">
        <div class="key">单人可领取次数</div>
        <div class="value">
          <el-input class="w500" v-model="coupons.oneCount" placeholder="请填写数字，-1表示没有数量上限"></el-input>
        </div>
      </div>

      <div class="line">
        <div class="key">使用说明</div>
        <div class="value">
          <el-input class="w500" v-model="coupons.couponsDescribe" placeholder="优惠券描述"></el-input>
        </div>
      </div>

      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getCouponsById, newVue, updateCoupons} from "../../network/coupons";

  export default {
    name: "CouponsInsert",
    data(){
      return{
        coupons: {},
        couponsId: '',
        couponsType:[
          {
            value: '固定金额',
            label: '固定金额'
          },{
            value: '折扣',
            label: '折扣'
          },{
            value: '固定可叠加',
            label: '固定可叠加'
          },
        ],
        supportScenarios:[
          {
            value: '全部商品',
            label: '全部商品'
          },{
            value: '普通商品',
            label: '普通商品'
          },{
            value: '拼团商品',
            label: '拼团商品'
          },
        ],
        getScenarios:[
          {
            value: '全部场景',
            label: '全部场景'
          },{
            value: '自主领取',
            label: '自主领取'
          },{
            value: '活动赠送',
            label: '活动赠送'
          },
        ]
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/coupons/list";
      this.common.HeaderLocationTwo.name =  "优惠券管理"
      this.common.HeaderLocationThree.name = "新增or修改优惠券信息"
      if (this.$route.params.id!=null){
        this.couponsId = this.$route.params.id;

        getCouponsById(this.couponsId).then(res => {
          this.coupons = res.data;
        })
      }


    },
    methods: {
      backClick(){
        this.$router.push("../list");
      },
      submit(){
        updateCoupons(this.coupons).then(res => {
          console.log(res);
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }
</style>
